import { Valuable } from "../type/DataRecord";

const sortByValue = (data: Valuable[]): Valuable[] =>
  data.sort((row1, row2) => row2.value - row1.value);

export default sortByValue;
